<div class="w-100">
  <akeela-preview-doc [identifier]="identifier"></akeela-preview-doc>
</div>
<i class="fas fa-spinner fa-spin fa-2x" *ngIf="loading"></i>
<p *ngIf="loading">Cargando vista previa...</p>